<template>
  <div class="static-banner">
    <div class="module-title">
      <h4>{{ $t('message.staticBannerEdit') }}</h4>
      <el-button type="primary" :loading="saving" @click="saveBanner">
        {{ $t('message.save') }}
      </el-button>
    </div>

    <!-- 三个字段同时为空时，后端会清空首页静态横幅。 -->
    <el-form :model="banner" label-width="120px" class="banner-form">
      <el-form-item :label="$t('message.bannerMainTitle')">
        <el-input v-model="banner.title1" clearable />
      </el-form-item>
      <el-form-item :label="$t('message.bannerSubtitle')">
        <el-input v-model="banner.title2" clearable />
      </el-form-item>
      <el-form-item :label="$t('message.skipLinks')">
        <el-input v-model="banner.link" clearable />
      </el-form-item>
    </el-form>

    <div class="preview-title">{{ $t('message.resultspreview') }}</div>
    <!-- 输入内容实时展示，便于保存前确认首页横幅效果。 -->
    <div class="banner-preview">
      <div class="banner-icon">
        <i class="el-icon-warning-outline"></i>
      </div>
      <div class="banner-content">
        <div class="title-row">
          <span class="new-label">{{ $t('message.newColumn') }}</span>
          <strong>{{ banner.title1 }}</strong>
        </div>
        <p>{{ banner.title2 }}</p>
      </div>
      <a class="banner-link" v-if="banner.link" :href="banner.link" target="_blank" rel="noopener noreferrer">
        {{ $t('message.readMore') }}
        <i class="el-icon-right"></i>
      </a>
      <span class="banner-link" v-else>
        {{ $t('message.readMore') }}
        <i class="el-icon-right"></i>
      </span>
      <div class="banner-decoration"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      saving: false,
      banner: {
        title1: '',
        title2: '',
        link: '',
      },
    }
  },
  created() {
    this.getBanner()
  },
  methods: {
    // 获取当前静态横幅配置，接口未配置时三个字段均为空字符串。
    getBanner() {
      this.$api.siteConfiguration.staticBannerGet().then(res => {
        this.banner = {
          title1: res.data.value.title1,
          title2: res.data.value.title2,
          link: res.data.value.link,
        }
      })
    },
    // 保存接口直接接收三个横幅字段，全部为空表示清空横幅。
    saveBanner() {
      this.saving = true
      this.$api.siteConfiguration.staticBannerSave(this.banner).then(res => {
        this.$message.success(res.msg)
        this.getBanner()
      }).finally(() => {
        this.saving = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.static-banner {
  width: 1400px;
  margin: 0 auto 50px;

  .module-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    h4 {
      color: #000;
      font-size: 21px;
      font-weight: 600;
    }
  }

  .banner-form {
    padding: 24px 30px 6px;
    background: #fff;
    border-radius: 6px;

    /deep/ .el-input {
      max-width: 900px;
    }
  }

  .preview-title {
    margin: 20px 0 10px;
    font-size: 16px;
    font-weight: 600;
  }

  .banner-preview {
    position: relative;
    display: flex;
    align-items: center;
    min-height: 68px;
    padding: 0 24px;
    overflow: hidden;
    background: #fff7f7;
    border: 1px solid #f1d3d3;
    border-radius: 6px;

    .banner-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 38px;
      height: 38px;
      margin-right: 18px;
      color: #fff;
      font-size: 20px;
      background: #c62d32;
      border-radius: 50%;
    }

    .banner-content {
      flex: 1;

      .title-row {
        margin-bottom: 7px;
        color: #333;
        font-size: 16px;

        .new-label {
          margin-right: 14px;
          color: #c62d32;
          font-size: 13px;
          font-weight: 600;
        }
      }

      p {
        color: #8a8a8a;
        font-size: 13px;
      }
    }

    .banner-link {
      position: relative;
      z-index: 1;
      padding: 11px 22px;
      color: #fff;
      font-size: 14px;
      font-weight: 600;
      background: #bd252b;
      border-radius: 22px;

      i {
        margin-left: 8px;
      }
    }

    .banner-decoration {
      position: absolute;
      right: 12px;
      width: 60px;
      height: 60px;
      border: 2px solid rgba(198, 45, 50, 0.12);
      border-radius: 10px;
      transform: rotate(-8deg);
    }
  }
}
</style>
